import { useTranslator } from '@/translations/translator';
import moment from 'moment';
import { useEffect } from 'react';

export function useConfigureLocales() {
    const t = useTranslator();

    useEffect(() => {
        moment.locale(t.locale);
    }, [t.locale]);
}
